(() => {
const $b1689668b2d3b33e$var$tns = typeof window !== "undefined" && window.tns;
const $b1689668b2d3b33e$var$sliders = document.getElementsByClassName("slider");
if (!$b1689668b2d3b33e$var$tns) ;
else [
    ...$b1689668b2d3b33e$var$sliders
].forEach((element, index, array)=>{
    const slide = $b1689668b2d3b33e$var$sliders[index];
    const thisSlide = $b1689668b2d3b33e$var$tns({
        container: slide,
        loop: true,
        speed: 1000,
        items: 1,
        gutter: 0,
        autoWidth: false,
        autoHeight: true,
        autoplayResetOnVisibility: true,
        /* To Do - Get Lazy Load Working Smoothly */ lazyload: false,
        slideBy: "page",
        controls: false,
        nav: true,
        navPosition: "bottom",
        preventActionWhenRunning: true,
        mouseDrag: true,
        touch: true,
        responsive: {
            "0": {
                gutter: 30
            },
            "769": {
                gutter: 20
            }
        },
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        autoplayPosition: "bottom",
        autoplayButtonOutput: false,
        onInit: function(info) {
            // Fix CSS transition that's set to 0s by default
            info.container.style.transition = 'transform 1000ms ease';
        }
    });
    // Handle Strange Speed Up Issues on Drag
    thisSlide.events.on('dragStart', function() {
        thisSlide.pause();
    });
    thisSlide.events.on('dragMove', function() {
        thisSlide.pause();
    });
    thisSlide.events.on('dragEnd', function() {
        thisSlide.pause();
    });
});

})();
//# sourceMappingURL=content-slider.js.map
